import intersectionWith from 'lodash/intersectionWith';

export const createSelectOptionsFromSysEnums = sysEnums => sysEnums && sysEnums.map(
	enumObject => ({
		value: enumObject.id,
		label: enumObject.text || enumObject.title || enumObject.email || enumObject.country_name
	})
);

export const createSelectValuesUseIntersection = (selectOptions = [], savedValues = []) => (
	intersectionWith(selectOptions, savedValues, (selectOptions, savedValues) => selectOptions.value === savedValues)
);

export const createSelectOptionsFromSysEnumsForCountries = (sysEnums) => {
	return sysEnums && sysEnums.map(
		enumObject => ({
			value: enumObject.id,
			label: enumObject.text || enumObject.title || enumObject.name,
			country_code: enumObject.country_code ? enumObject.country_code.toLowerCase() : ''
		}));
};


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/form-elements/select/index.js